export default __webpack_public_path__ + "static/media/february-min.f8b4c33e.jpg";